import { decryptString } from './encrypt';

// At runtime (deployed), values come from window.contextvars which is served dynamically
// by the Python backend from Azure App Service environment variables.
// Locally, fall back to process.env (CRA injects .env values at build time).
function getRuntimeEnv(key) {
  return (
    (typeof window !== 'undefined' && window.contextvars && window.contextvars[key]) ||
    process.env[key] ||
    ''
  );
}

export function normalizeApiBaseUrl(apiBaseUrl) {
  if (!apiBaseUrl) {
    return '';
  }

  return apiBaseUrl.replace(/\/+$/, '');
}

export function getSameOriginApiBaseUrl() {
  if (typeof window === 'undefined') {
    return '';
  }

  return `${window.location.origin}/api`;
}

export function ensureApiBaseUrl(apiBaseUrl) {
  const normalizedApiBaseUrl = normalizeApiBaseUrl(apiBaseUrl);

  if (!normalizedApiBaseUrl || typeof window === 'undefined') {
    return normalizedApiBaseUrl;
  }

  try {
    const parsedUrl = new URL(normalizedApiBaseUrl);
    const isSameOrigin = parsedUrl.origin === window.location.origin;
    const hasExplicitPath = parsedUrl.pathname && parsedUrl.pathname !== '/';

    if (isSameOrigin && !hasExplicitPath) {
      return getSameOriginApiBaseUrl();
    }
  } catch (error) {
    return normalizedApiBaseUrl;
  }

  return normalizedApiBaseUrl;
}

export function shouldWaitForApiBootstrap(bootstrap = {}) {
  return !bootstrap.apiBaseUrl || !bootstrap.chatId;
}

export function getQueryBootstrap(search = window.location.search) {
  const params = new URLSearchParams(search);
  const chatIdEncrypted = params.get('chatId') || '';
  const fallbackApiBaseUrl = getSameOriginApiBaseUrl();
  let rawChatId = '';
  let apiToken = '';

  if (chatIdEncrypted) {
    try {
      const decryptedData = decryptString(
        chatIdEncrypted,
        getRuntimeEnv('REACT_APP_ENCRYPTION_KEY') // its a key
      );
      [rawChatId = '', apiToken = ''] = decryptedData.split('~');
    } catch (error) {
      rawChatId = '';
      apiToken = '';
    }
  }

  return {
    apiBaseUrl: ensureApiBaseUrl(
      getRuntimeEnv('REACT_APP_RAMMAS_API_BASE_URL') || fallbackApiBaseUrl
    ),
    apiToken,
    chatId: chatIdEncrypted,
    // rawChatId,
    isArabic: params.get('isArabic') || '',
  };
}

export function buildApiUrl(apiBaseUrl, path) {
  const normalizedBaseUrl = ensureApiBaseUrl(apiBaseUrl);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${normalizedBaseUrl}${normalizedPath}`;
}

export function buildApiHeaders(headers = {}) {
  const apiToken = getQueryBootstrap().apiToken;

  if (!apiToken || headers.Authorization || headers.authorization) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${apiToken}`,
  };
}

export function buildEncryptedCredentialBody(encryptedChatId, body = {}) {
  return {
    ...body,
    chatId: encryptedChatId,
  };
}
